import { InvestmentDataType } from '../types/investmentApi.types'
import { InvestmentRowModel } from '../types/investmentSection.types'

export function buildPrimaryInvestmentRowModel({
  investmentData
}: {
  investmentData: InvestmentDataType
}): InvestmentRowModel {
  const firstName = investmentData?.secondaryUserName?.split(' ')?.[0]?.trim() || 'Family'

  return {
    key: 'primary-user-investment',
    investmentDataOverride: investmentData,
    titleLeadingText: investmentData?.throughFamilyAccess ? firstName : 'Your',
    titleTrailingText: investmentData?.throughFamilyAccess ? "'s Investment" : '\u00A0Investment',
    iconInitial: investmentData?.throughFamilyAccess ? firstName?.charAt(0)?.toUpperCase() || '' : '',
    temporaryFamilyAccessToken: ''
  }
}
